import { DEFAULT_EE_VALUE } from 'src/constants/diet';
import { AccountType, NoteType } from 'src/types';
import { getDefaultTarget } from 'src/utils';
export var isValidPageMode = function isValidPageMode(mode) {
  return Object.values(NOTE_PAGE_MODE).includes(mode);
};
export var NOTE_PAGE_MODE;

(function (NOTE_PAGE_MODE) {
  NOTE_PAGE_MODE["VIEW_ALL"] = "view_all";
  NOTE_PAGE_MODE["FULLSCREEN"] = "fullscreen";
  NOTE_PAGE_MODE["MODERN_EDITOR"] = "modern_editor";
  NOTE_PAGE_MODE["CLASSICAL_EDITOR"] = "classical_editor";
  NOTE_PAGE_MODE["DAY_SUMMARY"] = "day_summary";
})(NOTE_PAGE_MODE || (NOTE_PAGE_MODE = {}));

export var DietRecordContextDefaultValue = {
  modalEditorContainerRef: null,
  classicalSideMenuContainerRef: null,
  noteTags: [],
  daySummaries: [],
  clientInfo: {
    birthday: '',
    avatar_url: '',
    name: '',
    gender: '',
    targetWeight: 0,
    id: 0,
    current: {
      weight: 0
    }
  },
  groupedMeasurements: {},
  datesHaveUploadNotes: [],
  notes: [],
  allDatesNotes: [],
  meals: {},
  hormoneScores: '',
  hormoneType: '',
  selectedDate: new Date(),
  sixFoodCategorySummary: [],
  sixFoodCategoryByMeal: [],
  target: getDefaultTarget(DEFAULT_EE_VALUE),
  targets: [],
  profile: {
    authenticated: false,
    access_token: '',
    role: [],
    logout: function logout() {},
    setUpAccessToken: function setUpAccessToken() {},
    setRole: function setRole() {},
    profile: {},
    name: '',
    orgID: ''
  },
  calorieSummary: {
    target: 0,
    ingested: 0,
    burned: 0,
    rest: 0
  },
  waterIntake: 0,
  isLoadingDiaries: false,
  setSelectedDate: function setSelectedDate() {},
  handleWeekChange: function handleWeekChange() {},
  pageMode: NOTE_PAGE_MODE.VIEW_ALL,
  goToMode: function goToMode() {},
  measurements: [],
  currentNote: {
    id: 0,
    calorie: 0,
    date: '',
    sixFoodCategorySummary: [],
    assets: [],
    client_id: 0,
    taken_at: '',
    text: '',
    updated_at: '',
    created_at: '',
    type: NoteType.FoodNote,
    comments: [],
    items: [],
    member_id: 0,
    member_type: AccountType.client,
    protein: 0,
    fat: 0,
    data: {},
    carbohydrate: 0,
    meat_beans_high_fat: 0,
    meat_beans_low_fat: 0,
    meat_beans_medium_fat: 0,
    meat_beans_super_high_fat: 0,
    vegetables: 0,
    grains: 0,
    oil: 0,
    milk_low_fat: 0,
    milk_skim: 0,
    milk_whole_fat: 0,
    fruits: 0
  }
};